<div>
  <!-- Show fund name with link (when fund link is present) along with notification, if any. -->
  <p class="spacing--none ag-cell-fund-name">
    <eds-link-item
      *ngIf="fundLink"
      class="ag-cell-frk--link"
      [href]="fundLink"
      eventId="linkOrButtonClick"
    >
      {{ fundName }}
    </eds-link-item>

    <span *ngIf="!fundLink">{{ fundName }}</span>

    <!-- Show alert notification with message, only if 'actuals' posted. -->
    <eds-notifications
      *ngIf="actualsAlert"
      [title]="'products.capgains-fund-alert' | translate"
      [notificationType]="notificationType"
      [inline]="true"
      [small]="true"
    ></eds-notifications>
  </p>
</div>
